import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import { Card, Input, Typography } from "@material-tailwind/react";
import { handleErrorMessage } from "../../utility";
import api from "../../services/apiService";
import ApiRoutes from "../../services/apiRoutes";
import { useMutation } from "react-query";
import * as yup from "yup";
import ErrorParagraph from "../../components/common/ErrorParagraph";
import LoadingButton from "../../components/common/buttons/LoadingButton";
import logo from "../../assets/images/logo.svg";
import { routerPaths } from "../../services/path";
import { useForgotPasswordStore } from "../../store/onboarding/Onboarding";

const ForgotPasswordValidation = yup.object().shape({
  email: yup
    .string()
    .email("Invalid email address")
    .required("Email is required"),
});

function ForgotPassword() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(ForgotPasswordValidation),
    mode: "onChange",
  });

  const { setEmail } = useForgotPasswordStore();

  const navigate = useNavigate();
  const forgotPasswordMutation = useMutation(
    (data: { email: string }) =>
      api.post(ApiRoutes.forgotPassword, {}, { params: { email: data.email } }),
    {
      onSuccess: (variables) => {
        setEmail(variables.config.params.email);
        navigate(routerPaths.resetPassword);
      },
      onError: (error) => {
        handleErrorMessage(
          error,
          "Unable to send password reset email. Please try again later."
        );
      },
    }
  );

  const onSubmit = (data: { email: string }) => {
    console.log(data);

    forgotPasswordMutation.mutate(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="lg:flex w-screen md:h-screen bg-gray-50">
        <div className="invisible lg:visible bg-map-background bg-no-repeat w-3/6 relative flex flex-col justify-center items-center">
          <img
            className="  absolute md:top-10 md:left-20"
            src={logo}
            alt="GIGM Logo"
          />
          <div className="text-4xl">
            <h1>It’s easier to get</h1>
            <h2 className="inline">started with{` `}</h2>
            <h2 className="inline font-extrabold text-primary">GIGM Boat</h2>
          </div>
        </div>
        <img className="ml-20 md:hidden" src={logo} alt="GIGM Logo" />
        <div className="flex items-center justify-center ">
          <div className="md:w-[60%] md:m-24 m-10">
            <h2 className=" text-2xl text-center">Forgot Password</h2>
            <h2 className=" text-sm text-center mt-5 text-gray-600">
              Hi there, kindly provide your email to rest your password
            </h2>
            <Card placeholder={undefined} color="transparent" shadow={false}>
              <div className="mt-8 mb-2 w-80 max-w-screen-lg sm:w-96 my-auto ">
                <div className="mb-1 flex flex-col gap-6">
                  <Typography
                    placeholder={undefined}
                    variant="paragraph"
                    color="blue-gray"
                    className="-mb-3"
                  >
                    Email
                  </Typography>
                  <Input
                    crossOrigin={undefined}
                    size="lg"
                    placeholder="name@mail.com"
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900 bg-white"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                    {...register("email")}
                  />
                  {errors.email && (
                    <ErrorParagraph message={errors.email.message!} />
                  )}
                  <LoadingButton isLoading={forgotPasswordMutation.isLoading}>
                    Send Reset Link
                  </LoadingButton>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </form>
  );
}

export default ForgotPassword;
